module.exports = __webpack_public_path__ + "img/10.34a778a9.png";